import { render, staticRenderFns } from "./nodata-for-detail.vue?vue&type=template&id=6cbde044&scoped=true"
import script from "./nodata-for-detail.vue?vue&type=script&lang=js"
export * from "./nodata-for-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbde044",
  null
  
)

export default component.exports